import { motion } from "framer-motion";
import { process } from "../data";
import { Reveal } from "./Primitives";

export const Process = () => {
  return (
    <section id="process" className="py-24 sm:py-32 bg-white border-y border-black/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <div className="max-w-2xl mb-20">
            <span className="text-sm font-medium text-[#A1A1AA] tracking-wide">How it works</span>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl font-light tracking-tight leading-tight">
              A simple process, <span className="aes-gradient-text font-medium">zero guesswork</span>.
            </h2>
            <p className="mt-5 text-lg text-[#52525B] leading-relaxed">
              From first call to launch — clear steps, no risk, and a free demo before you ever commit.
            </p>
          </div>
        </Reveal>

        <div className="relative">
          <motion.div
            aria-hidden
            className="hidden lg:block absolute top-[2.1rem] left-0 right-0 h-px aes-gradient origin-left"
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2, ease: "easeInOut" }}
          />
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
            {process.map((p, i) => (
              <Reveal key={p.step} delay={i * 0.12}>
                <div className="relative" data-testid={`process-step-${i}`}>
                  <div className="relative z-10 h-9 w-9 rounded-full bg-white border border-black/10 flex items-center justify-center mb-6">
                    <span className="font-display text-sm font-semibold aes-gradient-text">{p.step}</span>
                  </div>
                  <h3 className="font-display text-xl font-medium tracking-tight">{p.title}</h3>
                  <p className="mt-3 text-[#52525B] leading-relaxed">{p.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
